import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { DestinationReasonsService } from 'app/core/service/destination-reasons.service'
import { DestinationReasonsAction } from '../constants/destination-reasons.constants'
import {
    GetDestinationReasons,
    GetDestinationReasonsSuccess,
    GetDestinationReasonsError,
    GetDestinationReasonById,
    GetDestinationReasonByIdSuccess,
    GetDestinationReasonByIdError,
    PostDestinationReason,
    PostDestinationReasonSuccess,
    PostDestinationReasonError,
    PutDestinationReason,
    PutDestinationReasonSuccess,
    PutDestinationReasonError,
    DeleteDestinationReason,
    DeleteDestinationReasonSuccess,
    DeleteDestinationReasonError
} from '../actions/destination-reasons.actions'

@Injectable()
export class DestinationReasonsEffects {
  getDestinationReasons$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetDestinationReasons>(DestinationReasonsAction.GetDestinationReasons),
      switchMap(() =>
        this.destinationReasonsService.getDestinationReasons().pipe(
          mergeMap((destinationReasons: any) => {
            return of(new GetDestinationReasonsSuccess(destinationReasons));
          }),
          catchError((error) => {
            return of(new GetDestinationReasonsError());
          }),
        )
      ),
    ),
  );

  getDestinationReasonById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetDestinationReasonById>(DestinationReasonsAction.GetDestinationReasonById),
      switchMap((action) =>
        this.destinationReasonsService.getDestinationReasonById(action.id).pipe(
          mergeMap((destinationReason: any) => {
            return of(new GetDestinationReasonByIdSuccess(destinationReason));
          }),
          catchError((error) => {
            return of(new GetDestinationReasonByIdError());
          }),
        )
      ),
    ),
  );

  postDestinationReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PostDestinationReason>(DestinationReasonsAction.PostDestinationReason),
      switchMap((action) =>
        this.destinationReasonsService.postDestinationReason(action.data).pipe(
          mergeMap((destinationReason: any) => {
            return of(new PostDestinationReasonSuccess(destinationReason));
          }),
          catchError((error) => {
            return of(new PostDestinationReasonError());
          }),
        )
      ),
    ),
  );

  putDestinationReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<PutDestinationReason>(DestinationReasonsAction.PutDestinationReason),
      switchMap((action) =>
        this.destinationReasonsService.putDestinationReason(action.data).pipe(
          mergeMap((destinationReason: any) => {
            return of(new PutDestinationReasonSuccess(destinationReason));
          }),
          catchError((error) => {
            return of(new PutDestinationReasonError());
          }),
        )
      ),
    ),
  );

  deleteDestinationReason$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteDestinationReason>(DestinationReasonsAction.DeleteDestinationReason),
      switchMap((action) =>
        this.destinationReasonsService.deleteDestinationReason(action.id).pipe(
          mergeMap(() => {
            return of(new DeleteDestinationReasonSuccess(action.id));
          }),
          catchError((error) => {
            return of(new DeleteDestinationReasonError());
          }),
        )
      ),
    ),
  );

  constructor(
    private destinationReasonsService: DestinationReasonsService,
    private actions$: Actions,
  ) {}
}